import React from 'react';

// BarTrigger is the in-page control for trigger=bar against an overlay surface
// (decision #4963): a search bar the visitor sees before searching, which opens
// the overlay the layout selects rather than holding results itself.
//
// It is a button, not an input. Typing happens in the overlay's own input,
// which autofocuses on open; a second input here would take the first
// keystroke and then hand focus away mid-word. The placeholder doubles as the
// button's accessible name, so the control reads as what it does.
//
// Styles are inline for the same reason the rest of the widget's are: the
// standalone bundle's shadow root is deliberately unstyled and cannot see the
// host page's vo-search.css. The class is for host pages to target.
export function BarTrigger({ merged = {}, onOpen, hidden = false }) {
  const label = merged.searchPlaceholder || 'Search...';

  return (
    <button
      type="button"
      className="vo-search-bar-trigger"
      onClick={onOpen}
      style={{
        '--primary-color': merged.primaryColor,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        width: '100%',
        padding: '10px 14px',
        cursor: 'text',
        textAlign: 'left',
        color: merged.inputTextColor,
        background: merged.inputBackgroundColor,
        border: `1px solid ${merged.borderColor || 'currentColor'}`,
        borderRadius: '8px',
        font: 'inherit',
        // A scoped overlay is a sibling of this control rather than a layer
        // over the document, so it is drawn on top of it (item #8771). Hidden
        // rather than unmounted, so the host's layout does not move.
        ...(hidden ? { visibility: 'hidden' } : {}),
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke={merged.inputIconColor || 'currentColor'}
        strokeWidth="2"
        width="18"
        height="18"
        aria-hidden="true"
        style={{ flex: 'none' }}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" fill="none" />
      </svg>
      <span className="vo-search-bar-trigger-label">{label}</span>
    </button>
  );
}
